      <template>
          <div class="container mt-5">
              <TokenHoldersTable :page="showTop" :data="tokenHoldesList" :tokenInfo="tokenInfo"/>
          </div>
      </template>

      <script>
      import TokenHoldersTable from "@/views/comp_table/token_holders_table";
      export default {
      name: "holders",
        components: { TokenHoldersTable},
        data() {
          return {
            showTop:'showTop',//显示分页
            tokenInfo: null,
            address:'',
            tokenHoldesList:null
          }
        },
        methods:{
          async getTokenInfo(){

            let v = this
            let result = await v.api('tokenInfo',{
              address : v.address
            },{
              vue: v,
              key_data: 'data',
            })
            // console.log('getTokenInfo',result)
            if (result.code==200) {
              v.tokenInfo = result.data.tokenInfo
              v.getTokenHoderList();
            }
          },
          async getTokenHoderList(){
            let v = this;
            let result = await v.api('tokenHoderList', {
              page: 1,
              size: 10000,
              address : v.address,
              type: v.tokenInfo.type
            }, {
              vue: v,
              key_data: 'data',
            })
            // console.log('getTokenHoderList',result)
            if (result.code==200) {
              v.tokenHoldesList = result.data.list
            }
          }
        },
        mounted() {
          this.address = this.$route.params.number
          this.getTokenInfo();
        },
      }
      </script>

      <style scoped>

      </style>
